import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElaborazioniClimaticheComponent } from './elaborazioni-climatiche.component';



@NgModule({
  declarations: [ElaborazioniClimaticheComponent],
  imports: [
    CommonModule
  ],
  exports:[ElaborazioniClimaticheComponent]
})
export class ElaborazioniClimaticheModule { }
